export default __webpack_public_path__ + "static/media/page_not_found.e6169ac6.svg";